import { notEmpty } from "@product/scmp-sdk";
import { useMemo } from "react";
import { graphql, useFragment } from "react-relay";

import type { hooksNewsAgendaFilter$key } from "~/queries/__generated__/hooksNewsAgendaFilter.graphql";

export const useNewsAgendaFilter = (
  reference: hooksNewsAgendaFilter$key,
  entityId: string | undefined,
) => {
  const data = useFragment(
    graphql`
      fragment hooksNewsAgendaFilter on TopicEdge @relay(plural: true) {
        node {
          ...itemAgendaItemTopic
          ...itemPlusNewsAgendaItemTopic
          entityId
          newsAgenda {
            newsAgendaOptions
            startDate
            endDate
          }
        }
      }
    `,
    reference,
  );

  const filtered = useMemo(
    () =>
      data
        .filter(({ node }) => notEmpty(node))
        .sort(({ node: a }, { node: b }) => {
          const startDateA = a.newsAgenda?.startDate ?? 0;
          const endDateA = a.newsAgenda?.endDate ?? 0;
          const startDateB = b.newsAgenda?.startDate ?? 0;
          const endDateB = b.newsAgenda?.endDate ?? 0;
          return startDateA === startDateB ? endDateA - endDateB : startDateA - startDateB;
        }),
    [data],
  );
  const selected = useMemo(() => {
    const hasDetailNodes = filtered
      .filter(({ node }) => !node?.newsAgenda?.newsAgendaOptions.includes("disable_detail_view"))
      .map(({ node }) => node?.entityId);

    if (hasDetailNodes.length === 0) {
      return null;
    }

    if (entityId && hasDetailNodes.includes(entityId)) {
      return entityId;
    }

    return hasDetailNodes[0];
  }, [filtered, entityId]);

  return {
    filtered,
    selected,
  };
};
